function updateCountdown() {
    var targetDate = new Date();
    targetDate.setHours(14, 0, 0, 0); // Set target time to 2pm
    var now = new Date();
    var timeDifference = targetDate - now;
    var dayOfWeek = now.getDay();

    var preCounterTextElement = document.querySelector("#pre-counter-text");
    var postTimerTextElement = document.querySelector(".post-timer-text");

    if (timeDifference <= 0) {
        if (preCounterTextElement) {
            preCounterTextElement.innerText = " "; 
        }

        if (dayOfWeek === 5 && now.getHours() >= 13 || dayOfWeek === 6 || dayOfWeek === 0) {
            targetDate.setDate(now.getDate() + (((1 + 7 - now.getDay()) % 7) || 7)); 
            if (postTimerTextElement) {
                postTimerTextElement.innerText = " to get it by tuesday"; 
            }
        } else {
            targetDate.setDate(now.getDate() + 1); 
            if (postTimerTextElement) {
                switch(dayOfWeek){
                    case 1: 
                        postTimerTextElement.innerText = "for delivery by Wednesday";
                        break;
                    case 2: 
                        postTimerTextElement.innerText = "for delivery by Thursday";
                        break;
                    case 3: 
                        postTimerTextElement.innerText = "for delivery by Friday";
                        break;
                    case 4: 
                        postTimerTextElement.innerText = "for delivery by Saturday";
                        break;
                }
            }
        }
    } 

    var timeDifference = targetDate - now;
    var hours = Math.floor( timeDifference / 3600000);
    var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

    var hoursElement = document.getElementById("hours");
    var minutesElement = document.getElementById("minutes");

    if (hoursElement) {
        hoursElement.innerText = String(hours).padStart(2, "0");
    }

    if (minutesElement) {
        minutesElement.innerText = String(minutes).padStart(2, "0");
    }
};

setInterval(updateCountdown, 1000);